import React, { Component } from 'react';
import weapons1 from '../assets/weapons1.png';
import logo2 from '../assets/logo2.png';

class ShopWeapons extends Component {
  render() {
    return (
      <div className="ShopWeapons">
        <h1>Thai-Aikikai Shop's Weapons</h1>

        <img className="weapons" src={weapons1} alt="weapons" />
        <h1>Bokken Tanto and Jo Set</h1>
        <h2>Bokken 1,000 Baht</h2>
        <h2>Jo 800 Baht</h2>
        <h2>Tanto 500 Baht</h2>
        <h2>Tsuba(Finger Guard) 200 Baht</h2>
        <br />

        <div>
          please click to order
        </div>
        <br />

        <div>Powered by</div>
        <img className="logo2" src={logo2} alt="New Wave Consulting Group" />
        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default ShopWeapons;
